import "core-js/modules/es.object.to-string.js";
import axios from "axios";
var instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
});
instance.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = 'multipart/form-data';
  config.headers['X-Requested-With'] = 'xmlhttprequest';
  return config;
}, function (err) {
  return Promise.reject(err);
  ;
});
instance.interceptors.response.use(function (res) {
  return res.data;
}, function (err) {
  return Promise.reject(err);
  ;
});
export default instance;